import { makeAutoObservable, runInAction } from 'mobx';
import { requestGet } from '../../services/real.backend';

class Dictionaries {
  userGroups = {}

  constructor() {
    makeAutoObservable(this);
  }

  loadDictionaries = () => requestGet('/api/dictionaries')
    .then((dicts) => {
      if (dicts && dicts.groups) {
        runInAction(() => {
          this.userGroups = { ...dicts.groups };
        });
        return dicts;
      }
      Promise.resolve(true);
    })
    .catch((e) => console.log(e))
}

const dictionaries = new Dictionaries();

export default dictionaries;
